import { render } from "./ForecastMain.vue?vue&type=template&id=b19a6b54"
import script from "./ForecastMain.vue?vue&type=script&lang=js"
export * from "./ForecastMain.vue?vue&type=script&lang=js"

import "./ForecastMain.vue?vue&type=style&index=0&id=b19a6b54&lang=css"

import exportComponent from "/home/runner/work/etl/etl/outerspace-admin-2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__